import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "./IncidentBanner.css";

const IncidentBanner = forwardRef(({ onClose }, ref) => {
  const { t, ready } = useTranslation("common", { useSuspense: false });
  const text = (key, english) => (ready ? t(key, { defaultValue: english }) : english);

  return (
    <div ref={ref} className="incident-banner" role="alert">
      <i className="fas fa-circle-exclamation incident-banner__icon" aria-hidden="true" />
      <span className="incident-banner__title">
        {text("incidentBanner.title", "Service degradation")}
      </span>
      <span className="incident-banner__sep">—</span>
      <span className="incident-banner__message">
        {text(
          "incidentBanner.message",
          "Some features may be unavailable. Our team is working to restore normal service."
        )}
      </span>
      <div className="incident-banner__actions">
        <button type="button" className="incident-banner__btn" onClick={onClose} aria-label="Close">
          &times;
        </button>
      </div>
    </div>
  );
});

IncidentBanner.displayName = "IncidentBanner";

IncidentBanner.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default IncidentBanner;
